/* global Stripe */

import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['errors'];

  get publicKey() {
    return this.data.get('publicKey');
  }

  get productKey() {
    return this.data.get('productKey');
  }

  get clientRef() {
    return this.data.get('clientRef');
  }

  get clientEmail() {
    return this.data.get('clientEmail');
  }

  get successUrl() {
    return this.data.get('successUrl');
  }

  get cancelUrl() {
    return this.data.get('cancelUrl');
  }

  checkout(e) {
    e.preventDefault();
    const stripe = Stripe(this.publicKey);
    stripe
      .redirectToCheckout({
        items: [
          {
            sku: this.productKey,
            quantity: 1,
          },
        ],
        successUrl: this.successUrl,
        cancelUrl: this.cancelUrl,
        clientReferenceId: this.clientRef,
        customerEmail: this.clientEmail,
      })
      .catch((error) => {
        throw error;
      });
  }
}
